import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const DataPoints = memo(function DataPoints() {
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);
  const dataPoints = useSelector((state) => state.riskMembers.table.contacted_info);

  if (!dataPoints || !dataPoints.length) return null;

  return (
    <div className="data-points">
      {dataPoints.map((dataPoint) => {
        return (
          <div key={dataPoint.label} className="data-point">
            <DataDisplay
              disableAnimation={isUserQa}
              key={dataPoint.label}
              label={dataPoint.label}
              value={dataPoint.count}
              url={dataPoint.url}
              toolTipContent={dataPoint.tooltip || ""}
            />
          </div>
        );
      })}
    </div>
  );
});
